import React, { useEffect } from 'react';
import { useCarousel } from './CarouselContext';

type CarouselItemsElement = React.ElementRef<'div'>;
type CarouselItemsProps = React.ComponentPropsWithoutRef<'div'>;

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
export const CarouselItems = React.forwardRef<
  CarouselItemsElement,
  CarouselItemsProps
>((props, forwardedRef) => {
  const { index, internal_itemsCount, internal_setItemsCount } = useCarousel();
  // eslint-disable-next-line react-x/no-children-to-array -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it. (Replace Children.toArray with explicit item props.)
  const childrenArray = React.Children.toArray(props.children);
  const currentIndexChild = childrenArray[index];

  useEffect(() => {
    if (childrenArray.length !== internal_itemsCount) {
      internal_setItemsCount(childrenArray.length);
    }
  }, [childrenArray, internal_itemsCount, internal_setItemsCount]);

  return (
    <div
      {...props}
      className="flex items-center justify-center"
      ref={forwardedRef}
    >
      {currentIndexChild}
    </div>
  );
});

CarouselItems.displayName = 'CarouselItems';
